module.exports = __webpack_public_path__ + "static/24-93994ef72f1b0d4dc2b672a5f419b02f.jpg";